import { render, staticRenderFns } from "./AvatarButton.vue?vue&type=template&id=6c0284ae&"
import script from "./AvatarButton.vue?vue&type=script&lang=js&"
export * from "./AvatarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports